import { render, staticRenderFns } from "./MainCardSuccessStories.vue?vue&type=template&id=b068458e&scoped=true&"
import script from "./MainCardSuccessStories.vue?vue&type=script&lang=js&"
export * from "./MainCardSuccessStories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b068458e",
  null
  
)

export default component.exports